import React, { useState, useEffect } from 'react';
import './OrderListPage.css';
import orderApi from '../../../services/apiServices/orderApi';
import { setLoading } from '../../../services/redux/loadingSlice';
import { useDispatch } from 'react-redux';
import configService from '../../../services/configService';
import Pagination from '../../../components/common/Pagination/Pagination'; 
import { toast } from 'react-toastify';
import { putDateOnPattern } from '../../../utils/functions';
import FilterComponent from '../../../components/admin/FilterComponent/FilterComponent';
import { useNavigate } from "react-router-dom";
import EyeIcon from '../../../components/icons/EyeIcon';

const OrderListPage = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [totalItens, setTotalItens] = useState(0);
    const quantity = configService.getDefaultNumberOfItemsTable(); 
    const [showFilters, setShowFilters] = useState(false);
    const toggleFilters = () => setShowFilters(prev => !prev);
    const orderBy = "Created:Desc";

    useEffect(() => {
        const fetchOrders = async () => {
            dispatch(setLoading(true));
            try {
                const response = await orderApi.getOrdersPaginated({ page, quantity, orderBy, term: searchTerm, startDate, endDate, include: "Customer.User" });
                setItems(response.Results);
                setTotalPages(response.TotalPages);
                setTotalItens(response.TotalCount);
            } catch (error) {
                toast.error('Erro ao buscar os itens.');
            } finally {
                dispatch(setLoading(false));
            }
        };
        fetchOrders();
    }, [page, quantity, searchTerm, startDate, endDate, dispatch]);

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    const search = ({term, startDate, endDate} = {}) => {
        setSearchTerm(term);
        setStartDate(startDate);
        setEndDate(endDate);
    }

    const exportFunction = async (term) => {
        try {
            dispatch(setLoading(true));
            const response = await orderApi.exportOrders({ term: term });
            
            if (response.Status === 200 && response.Object) {
                window.open(response.Object, "_blank");
                toast.success('Relatório gerado com sucesso!');
            } else {
                toast.error('Erro ao gerar o relatório');
            }
        } catch (error) {
            toast.error('Erro ao gerar o relatório');
        }
        finally{
            dispatch(setLoading(false));
        }
    };

    const openItem = (code) => {
        navigate(`${code}`);
    }

    return (
    <div className="container-admin-page">
        <div className='title-with-options'>
            <h1>Lista de pedidos</h1>

            <button className="main-button" onClick={toggleFilters}>
                {showFilters ? 'Ocultar Filtros' : 'Mostrar Filtros'}
            </button>
        </div>

        {showFilters && (
            <div className='container-admin-page-filters div-with-border'>
                <h3>Filtros</h3>
                <FilterComponent
                    placeHolder={'Email do Cliente | Nome | Documento | Nº do pedido'}
                    showTermFilter={true}
                    showStartDate={true}
                    showEndDate={true}
                    submitFilter={search}
                    exportFunction={exportFunction}
                />
            </div>
        )}

        <div className='container-admin-page-table div-with-border'>
            <table className="admin-table">
                <thead>
                    <tr>
                        <th>Nº Pedido</th>
                        <th>Valor</th>
                        <th>Cliente</th>
                        <th>Status</th>
                        <th>Criado</th>
                        <th>Expiração</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                {items.map((item) => (
                    <tr key={item.Id}>
                        <td data-label='Nº Pedido'><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{item.NrOrder}</span></td>
                        <td data-label='Valor'><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{item.VlrFormat}</span></td>
                        <td data-label='Cliente'><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{item.Customer.User.Email}</span></td>
                        <td data-label='Status'><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{configService.getOrderDescription(item.OrderStatusId)}</span></td>
                        <td data-label='Criado'><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{putDateOnPattern(item.Created)}</span></td>
                        <td data-label='Expiração'><span className='option-link' onClick={() => openItem(`${item.Id}`)}>{putDateOnPattern(item.ExpirationDate)}</span></td>
                        <td><span className='option-link' onClick={() => openItem(`${item.Id}`)}><EyeIcon/></span></td>
                    </tr>
                ))}
                </tbody>
            </table>
            <sub>Total de Pedidos: {totalItens}</sub>
            <Pagination page={page} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    </div>
    );
};

export default OrderListPage;
